import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import HeaderLogo from "../assets/images/header-logo.svg";
import footerlogo from "../assets/images/footer-logo.svg";
import heart from "../assets/images/heart.svg";
// import applepay from "../assets/images/apple-pay.svg";
import usericon from "../assets/images/user-icon.svg";
import ordericon from "../assets/images/order-icon.svg";
import promotionicon from "../assets/images/promotion-icon.svg";
import giftmenuicon from "../assets/images/gift-menu-icon.svg";
import arrowwhite from "../assets/images/arrow-white.svg";
import carticon from "../assets/images/cart_icon.svg";
import { config } from "../config";
import { useDispatch, useSelector } from "react-redux";
import { authActions, configActions } from "../_actions";
import { status } from "../_constants";
import CustomLoader from "./CustomeLoader";
import { alert } from "../_utilities";
import { Helmet } from "react-helmet";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Modal } from "react-bootstrap";
import ShopCloseModel from "./ShopCloseModel";
import { domains } from "../domainConfig";
import { use } from "react";

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartData = useSelector((state) => state.cartList.cart_list_data);
  const conData = useSelector((state) => state.config);
  let userData = localStorage.getItem("userData");
  const [isShopIsClosed, setIsShopIsClosed] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isOpen, setIsopen] = useState(false);
  // const [user, setUser] = useState();
  // const [isLoader, setIsLoader] = useState(false);
  const [configData, setConfigData] = useState();
  const [loading, setLoading] = useState(true);
  const [isShow, setIsShow] = React.useState(false);
  let user =
    (localStorage.getItem("userData") &&
      JSON.parse(localStorage.getItem("userData"))) ||
    null;
  const authData = useSelector((state) => state.auth);

  const urlParams = new URLSearchParams(window.location.search);
  useEffect(() => {
    try {
      const token = urlParams.get("token");
      if (token != null) {
        dispatch(authActions.logout());
        localStorage.removeItem("userData");
        localStorage.removeItem("selectedAdress");
        localStorage.setItem("userData", JSON.stringify({ token: token }));
        setTimeout(() => {
          dispatch(authActions.userData());
        }, 500);
      }
    } catch (error) {}
  }, []);

  useEffect(() => {
    const token = urlParams.get("token");
    if (token && token !== null && token !== undefined) {
      if (authData && authData.user_data_status === status.SUCCESS) {
        if (token && token !== null && token !== undefined) {
          const userDatas = {
            customer: authData?.user_data_res?.data?.Customer,
            token: token,
          };
          localStorage.setItem("userData", JSON.stringify(userDatas));
          window.location.href = window.location.href.split("?")[0];
        }
      } else {
        if (authData && authData.user_data_status == 401) {
          dispatch(authActions.logout());
          localStorage.removeItem("userData");
          localStorage.removeItem("selectedAdress");
          navigate("/login");
        }
      }
    }
  }, [authData.user_data_res]);

  useEffect(() => {
    dispatch(configActions.loadConfigData());
    setLoading(true);
  }, []);

  // useEffect(() => {
  //   const storedUserData = localStorage.getItem("userData");
  //   console.log("48 ---------->", storedUserData);
  //   setUser(storedUserData ? JSON.parse(storedUserData) : null);
  // }, []);

  useEffect(() => {
    if (conData && conData?.config_status == status?.SUCCESS) {
      setConfigData(conData?.config_data);
      if (conData?.config_data && conData?.config_data.IsShopClosed == 1) {
        setIsShopIsClosed(true);
        console.log("<------------------  closed  ------------------>");
      }
      localStorage.setItem("configData", JSON.stringify(conData?.config_data));
      setLoading(false);
    }
  }, [conData?.config_data]);

  const ToggleSidebar = () => {
    isOpen === true ? setIsopen(false) : setIsopen(true);
  };
  // const redirectTo = (page) => {
  //   if (page && page === "signup") {
  //     setIsMenuOpen(false);
  //     navigate("/");
  //   } else if (page && page === "login") {
  //     setIsMenuOpen(false);
  //     navigate("/login");
  //   }
  // };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const sidebarRef = useRef(null);
  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsopen(false);
    }
  };

  const currentUrl = window.location.href;

  // Construct the WhatsApp share URL
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(currentUrl)}`;

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("selectedAdress");
    localStorage.removeItem("persist:root");
    localStorage.removeItem("deliveryType");
    localStorage.removeItem("deliverOrPickup");
    dispatch(authActions.logout());
    // setUser(null);
    user = null;

    setIsopen(false);
    navigate("/");
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          image: window.location.href,
          title: "Check this out!",
          text: "Visit this amazing website!",
          url: window.location.href,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      alert.error("Sharing is not supported on this device.");
    }
  };

  const handleUserActivityForApp = async () => {
    if (user && user.customer && user.customer.id) {
      try {
        if (domains.includes(window.location.hostname)) {
          if (cartData?.cartData && cartData?.cartData?.length > 0) {
            let response = await fetch(
              `${config.socketLiveApiUrl}/api/publish_user`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  serverDomain: `${config.localApiUrl}/`,
                  id: user?.customer?.id,
                }),
              }
            );
            let data = await response.json();
          } else {
            let response = await fetch(
              `${config.socketLiveApiUrl}/api/publish_inActive_user`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  serverDomain: `${config.localApiUrl}/`,
                  id: user?.customer?.id,
                }),
              }
            );
            let data = await response.json();
          }
        } else {
          if (cartData?.cartData && cartData?.cartData?.length > 0) {
            let response = await fetch(
              `${config.socketLocalApiUrl}/api/publish_user`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  serverDomain: `${config.localApiUrl}/`,
                  id: user.customer.id,
                }),
              }
            );
            let data = await response.json();
          } else {
            let response = await fetch(
              `${config.socketLocalApiUrl}/api/publish_inActive_user`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  serverDomain: `${config.localApiUrl}/`,
                  id: user.customer.id,
                }),
              }
            );
            let data = await response.json();
          }
        }
      } catch (error) {
        console.error("Error in user activity tracking:", error);
      }
    }
  };

  useEffect(() => {
    handleUserActivityForApp();
  }, [cartData]);
  const storeUserVisit = async () => {
    const response = await fetch(`${config.localApiUrl}/api/visitor`);
  };

  useEffect(() => {
    storeUserVisit();
  }, []);

  return (
    <>
      <Helmet>
        {/* Page Title */}

        <meta
          name="title"
          content={
            configData?.meta_title && configData?.meta_title !== "null"
              ? configData.meta_title
              : configData?.websiteName || "Burger Kings"
          }
        />
        {configData?.meta_description &&
          configData.meta_description.trim() !== "" &&
          configData.meta_description !== "null" && (
            <meta name="description" content={configData.meta_description} />
          )}

        {/* Meta Keywords */}
        {configData?.meta_keywords &&
          configData.meta_keywords.trim() !== "" &&
          configData.meta_keywords !== "null" && (
            <meta name="keywords" content={configData.meta_keywords} />
          )}

        {configData && configData.headerLogo ? (
          <meta
            property="og:image"
            content={`${config.localApiUrl}/tenancy/assets/${configData.headerLogo}`}
          />
        ) : (
          ""
        )}
      </Helmet>
      <header className="header-area">
        <div className="container">
          <div className="row flex-wrap-nowrap">
            <div className="col-lg-6 col-6">
              <div className="header-left">
                <Link to="/">
                  {configData && configData.headerLogo ? (
                    <img
                      src={`${config.localApiUrl}/tenancy/assets/${configData.headerLogo}`}
                      alt="Header Logo"
                      className={configData.logo_style}
                    />
                  ) : (
                    ""
                  )}
                </Link>
              </div>
            </div>
            <div className="col-lg-6 col-6">
              <div className="header-right">
                <div className="cart-icon">
                  {
                    <a
                      onClick={() =>
                        cartData &&
                        cartData.cartData &&
                        cartData.cartData.length <= 0 &&
                        alert.error("Please add items to cart first.!")
                      }
                      href={
                        cartData &&
                        cartData.cartData &&
                        cartData.cartData.length > 0
                          ? "/cart"
                          : "/menu"
                      }
                    >
                      <img src={carticon} alt="" />
                      {cartData &&
                        cartData.cartData &&
                        cartData.cartData.length > 0 && (
                          <span>{cartData.cartData.length}</span>
                        )}
                    </a>
                  }
                </div>
                <button
                  className={`menu-button ${isOpen == true ? "open" : ""}`}
                  onClick={ToggleSidebar}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </button>
                <nav
                  ref={sidebarRef}
                  className={`menu ${isOpen == true ? "open" : ""}`}
                >
                  <div className="sd-header">
                    <div className="menu-close" onClick={ToggleSidebar}>
                      <img src={arrowwhite} alt="" />
                    </div>
                  </div>
                  {userData == null ? (
                    <div className="hide-desk">
                      <div className="logo">
                        <img
                          src={
                            configData
                              ? `${config.localApiUrl}/tenancy/assets/${configData.headerLogo}`
                              : HeaderLogo
                          }
                          alt=""
                        />
                      </div>
                      <div className="signup-btn">
                        <Link to="/login" onClick={ToggleSidebar}>
                          <button
                            title="Sign Up"
                            className="btn-primary sm Sign-btn"

                            // onClick={() => redirectTo("signup")}
                          >
                            Sign Up
                          </button>
                        </Link>
                        <Link to="/login" onClick={ToggleSidebar}>
                          <button
                            title="Log in"
                            className="btn-primary sm login-btn"

                            // onClick={() => redirectTo("login")}
                          >
                            Log in
                          </button>
                        </Link>
                      </div>

                      {/*
                        <div className="menu-bottom-inner">
                        <div className="menu-bottom">
                          <div className="bottom-logo">
                            <img src={HeaderLogo} alt="" />
                          </div>
                          <div className="content">
                            <p>There’s more to love in the app.</p>
                            <button
                              title="Get the app"
                              className="btn-primary sm Get-the"
                            >
                              <div className="apple_pay" />
                              Get the app
                            </button>
                          </div>
                        </div>
                        <p className="loyalty-text">
                          made with
                          <em>
                            <img src={heart} alt="heart icon" />
                          </em>
                          by
                          <Link
                            to="https://sumoeats.co.uk/
                            onClick={ToggleSidebar}
                          >
                            <img src={footerlogo} alt="" />
                          </Link>
                        </p>
                        </div>
                        */}
                    </div>
                  ) : (
                    <div className="hide-desk">
                      <div className="logo">
                        <img src={usericon} alt="" />
                        <h2>{userData && userData?.customer?.first_name}</h2>
                        <p
                          onClick={() => {
                            setIsopen(false);
                            navigate("/account");
                          }}
                        >
                          Manage account
                        </p>
                      </div>
                      <div className="meno-menu">
                        <ul className="mobo-menu">
                          <li>
                            <Link
                              to="/orders"
                              onClick={() => {
                                setIsopen(false);
                              }}
                            >
                              <img src={ordericon} alt="" />
                              Orders
                            </Link>
                          </li>
                          {/* <li>
                            <Link to="#">
                              <img src={promotionicon} alt="" />
                              Promotions
                            </Link>
                          </li> */}
                          <li>
                            <a
                              onClick={handleShare}
                              style={{ cursor: "pointer" }}
                            >
                              <img src={giftmenuicon} alt="" />
                              Invite Friends
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="signup-btn">
                        <button
                          title="Sign Out"
                          className="btn-primary sm Sign-out-btn"
                          // onClick={() => {
                          //   localStorage.removeItem("userData");
                          //   setIsopen(false);
                          //   setUser("");
                          //   navigate("/");
                          // }}
                          onClick={handleLogout}
                        >
                          Sign Out
                        </button>
                      </div>
                      {/* <div className="menu-bottom-inner">
                        <div className="menu-bottom">
                          <div className="bottom-logo">
                            <img src={HeaderLogo} alt="" />
                          </div>
                          <div className="content">
                            <p>There’s more to love in the app.</p>
                            <button
                              title="Get the app"
                              className="btn-primary sm Get-the"
                            >
                              <div className="apple_pay" />
                              Get the app
                            </button>
                          </div>
                        </div>
                        <p className="loyalty-text">
                          made with
                          <em>
                            <img src={heart} alt="heart icon" />
                          </em>
                          by
                          <Link to="https://sumoeats.co.uk/">
                            <img src={footerlogo} alt="" />
                          </Link>
                        </p>
                      </div> */}
                    </div>
                  )}
                </nav>
              </div>
              <div
                className={`sidebar-overlay ${isOpen == true ? "active" : ""}`}
                onClick={ToggleSidebar}
              ></div>
            </div>
          </div>
        </div>

        {isShopIsClosed && (
          <ShopCloseModel setIsShopIsClosed={setIsShopIsClosed} />
        )}
      </header>
    </>
  );
}

export default Header;
